<template>
  <div class="block-content">
    <div class="container-calendar">
      <div
          v-for="city in selectDataByHost"
          class="block-calendar"
      >
        <header class="card-header has-text-centered">
          <strong class="card-header-title is-inline-block">
            {{ city.name }}
          </strong>
        </header>
        <div
            v-for="game in city.games"
            class="card-content card-content-calendar"
        >
          <div class="media">
            <div class="media-content has-text-centered">
              <div class="navbar-item has-dropdown is-hoverable has-text-centered">
                <router-link :to="{name: 'VenueDetails', params: {id: game.venueid}}" class="blockLink">
                  <b class="has-text-info has-text-centered">
                    {{ game.name }}
                  </b>
                </router-link>
                <div class="navbar-dropdown">
                  <router-link :to="{name: 'VenueDetails', params: {id: game.venueid}}">
                    <div class="card">
                      <div class="card-image">
                        <figure class="image is-2by1">
                          <img
                              :src="game.logo"
                              alt="Image"
                          >
                        </figure>
                      </div>
                      <div class="card-content">
                        <strong>{{ game.name }}</strong>
                        <div>{{ game.street1 }}</div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <strong class="is-darkred is-uppercase">{{ game.mark }}</strong><br>
              <span v-if="game.opttext && game.opturl">
                <a
                    :href="game.opturl"
                    target="_blank"
                >
                  {{ game.opttext }}
                </a>
                <br>
              </span>
              <!--Edit hosts for admin-->
              <div
                  v-if="user && user.canEditSchedule"
                  class="control"
              >
                <schedule-host :game="game" :fetched-hosts="fetchedHosts" :date="data[0].date" @setHost="setHost"
                               @makeDefault="makeDefault" :set-host-date="setHostDate"/>
                <!--                <div class="select is-small is-fullwidth mb-2">
                                  <select v-model="session">
                                    <option
                                      :selected="null"
                                      value=""
                                    >
                                      Choose Session
                                    </option>
                                    <option
                                      v-for="n in countStime(game)"
                                      :value="n"
                                    >
                                      Session {{ n }}
                                    </option>
                                  </select>
                                </div>
                                <div class="select is-small is-fullwidth mb-2">
                                  <select v-model="selectedHost">
                                    <option
                                      :selected="null"
                                      value=""
                                    >
                                      Schedule Host
                                    </option>
                                    <option
                                      v-for="host in fetchedHosts"
                                      :value="{hostId: host.id, venueId: game.venueid, session: session, gameDate: game.date}"
                                    >
                                      {{ fullName(host.first, host.last) }}
                                    </option>
                                  </select>
                                </div>-->
              </div>

              <time-block :game="game"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        v-if="!selectDataByHost.length"
        class="has-text-centered block-content"
    >
      <!--<h5 class="subtitle is-5">
        We could not find the selected host for this date
      </h5>-->
      <img
          src="/images/dps.png"
          width="280"
      >
    </div>
  </div>
</template>
<style scoped>
.blockLink {
  width: 100%;
}
</style>
<script>
import TimeBlock from './TimeBlock.vue'
import ScheduleHost from "@/components/calendar/ScheduleHost";

export default {
  name: 'CalendarTodayStyle',
  components: {
    ScheduleHost,
    TimeBlock
  },
  props: ['data', 'region', 'user', 'hosts', 'fetchedHosts', 'setHostDate', 'token', 'filteredHost'],
  data() {
    return {
      session: '',
      selectedHost: ''
    }
  },
  computed: {
    filteredByCity() {
      let cities = []
      for (let i = 0; i < this.data[0].venues.length; i++) {
        cities.push(this.data[0].venues[i].city)
      }
//        cities.sort()
      cities = cities.filter((item, pos) => {
        return cities.indexOf(item) === pos
      })
      let games = []
      for (let i = 0; i < cities.length; i++) {
        games[i] = []
      }
      for (let i = 0; i < this.data[0].venues.length; i++) {
        let index = cities.findIndex((city) => {
          return city === this.data[0].venues[i].city
        })

        games[index].push(this.data[0].venues[i])
      }
      let obj = []
      for (let i = 0; i < cities.length; i++) {
        obj.push(
            {
              name: cities[i],
              games: games[i]
            })
      }
      return obj
    },
    filteredByHost() {
      if (!this.filteredByCity.length) return []
      if (this.filteredHost === 'Select Host') return this.filteredByCity
      let arr = []
      this.filteredByCity.forEach(city => {
        let games = []
        city.games.forEach(game => {
          if (game.stime1_host && game.stime1_host.name === this.filteredHost) games.push(game)
          else if (game.stime2_host && game.stime2_host.name === this.filteredHost) games.push(game)
          else if (game.stime3_host && game.stime3_host.name === this.filteredHost) games.push(game)
          else if (game.stime4_host && game.stime4_host.name === this.filteredHost) games.push(game)
        })
        if (games.length) {
          arr.push({
            games,
            name: city.name
          })
        }
      })
      return arr
    },
    selectDataByHost() {
      return this.filteredByHost
//        if (this.user && this.user.canEditSchedule) return this.filteredByHost
//        return this.filteredByCity
    }
  },
  watch: {
    selectedHost(newValue) {
      if (newValue) {
        this.setHost()
        this.selectedHost = ''
      }
    }
  },
  methods: {
    fullName(first, last) {
      return `${first} ${last}`
    },
    setHost(date, session, venueId, hostId, gameDate) {
      this.$emit('setHost', date, session, venueId, hostId, gameDate)
    },
    makeDefault(calId, session, venueId, hostId) {
      this.$emit('makeDefault', calId, session, venueId, hostId)
    },
    countStime(venue) {
      let count = 0
      if (venue.hasOwnProperty('stime1') && venue.stime1) count++
      if (venue.hasOwnProperty('stime2') && venue.stime2) count++
      if (venue.hasOwnProperty('stime3') && venue.stime3) count++
      if (venue.hasOwnProperty('stime4') && venue.stime4) count++
      return count
    },
    setSession(n) {
      this.session = n
    }
  }
}
</script>
